export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8699.a6ecad43.jpg";